// extracted by mini-css-extract-plugin
export default {"tooltip":"hp-z","sharingV2":"ip-z","sharingIconsV2":"jp-z","links":"kp-z","link":"lp-z","facebookV2":"mp-z","twitterV2":"np-z","pinterestV2":"op-z"};